import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'next-i18next';
import { SignInput } from '@/module/auth/sign-up';
import { type CompanyEditFormData } from '../schema';
import { CommonEditForm } from './CommonEditForm';
import { PhoneSectionInForm } from './PhoneSectionInForm';
export const CompanyEditForm = () => {
  const {
    t
  } = useTranslation(['common']);
  const {
    register,
    formState: {
      errors
    }
  } = useFormContext<CompanyEditFormData>();
  return <>
      <CommonEditForm data-sentry-element="CommonEditForm" data-sentry-source-file="CompanyEditForm.tsx" />
      <SignInput isError={!!errors.companyName} label={{
      label: t('account.signup.companyName'),
      helperText: t('account.signup.exampleCompany')
    }} {...register('companyName', {
      maxLength: 30,
      setValueAs: value => value?.slice(0, 30)
    })} data-sentry-element="SignInput" data-sentry-source-file="CompanyEditForm.tsx" />
      <SignInput label={{
      label: t('account.signup.position'),
      subLabel: t('account.signup.select'),
      helperText: t('account.signup.exampleCompanyPosition')
    }} {...register('position', {
      maxLength: 30,
      setValueAs: value => value?.slice(0, 30)
    })} data-sentry-element="SignInput" data-sentry-source-file="CompanyEditForm.tsx" />
      <PhoneSectionInForm type="company" data-sentry-element="PhoneSectionInForm" data-sentry-source-file="CompanyEditForm.tsx" />
    </>;
};